import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../features/authSlice";
import Nav from "../nav/Nav";
import styles from "./layout.module.scss";

const Layout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    dispatch(logout());
    localStorage.removeItem("token");
    navigate("/connect", { replace: true });
  };

  // Ne pas afficher la navbar sur la page de connexion
  const shouldShowNav =
    !location.pathname.includes("/connect") &&
    !location.pathname.includes("/verify-email");

  return (
    <div className={styles.layout}>
      {shouldShowNav && <Nav onLogout={handleLogout} />}
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
